import {
  onboardingCategories,
  onboardingTopicContentTypes,
  onboardingWalkthroughs,
} from '@/constants/onboardingChecklist';

const titleCase = (slug) =>
  slug
    .split('-')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');

/**
 * `categoryId` is read once, not reactively — both call sites (`Tutorials/Panel.vue`,
 * `GetStarted/Widget.vue`) swap views with v-if/v-else, which remounts
 *
 * isAvailable checks content type
 */
export const useOnboardingTopics = (categoryId) => {
  const category = onboardingCategories.find((candidate) => candidate.id === categoryId);

  const topics = (category?.topicIds ?? []).map((topicId) => {
    const walkthrough = onboardingWalkthroughs.find((candidate) => candidate.id === topicId);
    const isAvailable = onboardingTopicContentTypes[topicId] === 'walkthrough';

    return {
      id: topicId,
      name: walkthrough?.name ?? titleCase(topicId),
      description: walkthrough?.description ?? '',
      infoText: walkthrough?.infoText ?? '',
      isAvailable,
    };
  });

  return { category, topics };
};
